import React, { memo } from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a0d00] py-16 px-4" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <div className="text-center mb-10" data-id="element-69">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-70">
            🥁 ¿Qué agrega el{' '}
            <span className="text-[#FF6B00]" data-id="element-71">Folklore Pro Elite™</span>?
          </h2>
          <p className="text-gray-300 text-base max-w-2xl mx-auto" data-id="element-72">
            Tu sistema de gestión, identidad y marketing profesional. Porque el
            folklore que enseñás ya era extraordinario. Este sistema hace que el
            mundo lo sepa.
          </p>
        </div>

        {/* Compact Comparison */}
        <div className="bg-black border border-[#FF6B00]/30 rounded-2xl overflow-hidden mb-10" data-id="element-73">
          <div className="grid grid-cols-3 bg-[#0d0600] border-b border-[#FF6B00]/30" data-id="element-74">
            <div className="p-3 font-bold text-white text-sm" data-id="element-75">Situación</div>
            <div className="p-3 font-bold text-gray-400 text-sm text-center border-l border-[#FF6B00]/30" data-id="element-76">
              Sin Folklore Pro Elite
            </div>
            <div className="p-3 font-bold text-[#FF6B00] text-sm text-center border-l border-[#FF6B00]/30" data-id="element-77">
              Con Folklore Pro Elite
            </div>
          </div>
          {[['Tu imagen profesional', 'Flyer hecho en PowerPoint', 'Identidad visual premium coherente'], ['Protección legal', 'Contrato verbal (ninguna)', 'Kit completo de documentos firmados'], ['Cobranza', 'Incómoda e irregular', 'Sistema sin drama en 5 pasos'], ['Atracción de alumnos', 'Solo boca a boca', 'Boca a boca + redes + sistema activo'], ['El alumno que se va', 'Sin aviso, sin sistema', 'Sistema de fidelización que lo retiene'], ['Tu precio', 'El de mercado o menos', '30-50% sobre el mercado justificado'], ['Tu Instagram', 'Irregular, sin estrategia', 'Calendario 30 días + sistema de contenidos'], ['Tu propuesta de valor', 'No la podés explicar', '1 oración que diferencia y vende']].map(([situation, without, withEco], i) => <div key={i} className="grid grid-cols-3 border-b border-gray-800 last:border-b-0" data-id="element-78">
              <div className="p-3 text-white text-xs sm:text-sm" data-id="element-79">
                {situation}
              </div>
              <div className="p-3 text-gray-500 text-xs sm:text-sm border-l border-gray-800 bg-gray-900/30" data-id="element-80">
                {without}
              </div>
              <div className="p-3 text-white text-xs sm:text-sm border-l border-gray-800 bg-[#FF6B00]/5" data-id="element-81">
                {withEco}
              </div>
            </div>)}
        </div>

        {/* Compact Modules List */}
        <div className="bg-black border border-[#FF6B00]/20 rounded-2xl p-6" data-id="element-82">
          <h3 className="text-xl font-black text-white text-center mb-5" data-id="element-83">
            ✅ FOLKLORE PRO ELITE™ INCLUYE:
          </h3>
          <div className="space-y-3" data-id="element-84">
            <div className="flex items-start gap-3" data-id="element-85">
              <span className="text-lg" data-id="element-86">🎯</span>
              <p className="text-sm text-white" data-id="element-87">
                <span className="font-bold" data-id="element-88">
                  Módulo 1 — Auditoría de Marca Docente
                </span>{' '}
                <span className="text-gray-400" data-id="element-89">
                  · Diagnóstico + plan de mejora de tus 5 pilares
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-90">
              <span className="text-lg" data-id="element-91">🎨</span>
              <p className="text-sm text-white" data-id="element-92">
                <span className="font-bold" data-id="element-93">
                  Módulo 2 — Identidad Visual Premium
                </span>{' '}
                <span className="text-gray-400" data-id="element-94">
                  · Colores, tipografías, fotos, bio y logo profesional
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-95">
              <span className="text-lg" data-id="element-96">📋</span>
              <p className="text-sm text-white" data-id="element-97">
                <span className="font-bold" data-id="element-98">
                  Módulo 3 — Kit de Inscripción Profesional
                </span>{' '}
                <span className="text-gray-400" data-id="element-99">
                  · 6 documentos editables en PDF listos para usar
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-100">
              <span className="text-lg" data-id="element-101">💰</span>
              <p className="text-sm text-white" data-id="element-102">
                <span className="font-bold" data-id="element-103">Módulo 4 — Gestión Financiera</span>{' '}
                <span className="text-gray-400" data-id="element-104">
                  · Calculadora de cuotas, cobranza y plan anual
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-105">
              <span className="text-lg" data-id="element-106">📱</span>
              <p className="text-sm text-white" data-id="element-107">
                <span className="font-bold" data-id="element-108">
                  Módulo 5 — Marketing Folklórico
                </span>{' '}
                <span className="text-gray-400" data-id="element-109">
                  · Contenido, calendario 30 días y publicidad en Meta
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-110">
              <span className="text-lg" data-id="element-111">🤝</span>
              <p className="text-sm text-white" data-id="element-112">
                <span className="font-bold" data-id="element-113">
                  Módulo 6 — Sistema de Fidelización
                </span>{' '}
                <span className="text-gray-400" data-id="element-114">
                  · Retención, referidos y renovación de alumnos
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-115">
              <span className="text-lg" data-id="element-116">📅</span>
              <p className="text-sm text-white" data-id="element-117">
                <span className="font-bold" data-id="element-118">
                  Módulo 7 — Plan de Implementación 30 Días
                </span>{' '}
                <span className="text-gray-400" data-id="element-119">
                  · Paso a paso diario con resultados desde la semana 1
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-120">
              <span className="text-lg" data-id="element-121">⚖️</span>
              <p className="text-sm text-white" data-id="element-122">
                <span className="font-bold" data-id="element-123">
                  Módulo 8 — Documentos Legales Listos
                </span>{' '}
                <span className="text-gray-400" data-id="element-124">
                  · Marco legal, monotributo y cartas profesionales
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}